export default __webpack_public_path__ + "static/media/25102001.6f8c612c.jpg";